var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3718_399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8335 10.0799C5.8335 9.61968 6.20659 9.24658 6.66683 9.24658H13.3335C13.7937 9.24658 14.1668 9.61968 14.1668 10.0799C14.1668 10.5402 13.7937 10.9132 13.3335 10.9132H6.66683C6.20659 10.9132 5.8335 10.5402 5.8335 10.0799Z",
    fill: "#324552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 5.91309C10.4604 5.91309 10.8335 6.28618 10.8335 6.74642L10.8335 13.4131C10.8335 13.8733 10.4604 14.2464 10.0002 14.2464C9.53993 14.2464 9.16683 13.8733 9.16683 13.4131L9.16683 6.74642C9.16683 6.28618 9.53993 5.91309 10.0002 5.91309Z",
    fill: "#324552"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.57975C5.85803 2.57975 2.50016 5.93762 2.50016 10.0798C2.50016 14.2219 5.85803 17.5798 10.0002 17.5798C14.1423 17.5798 17.5002 14.2219 17.5002 10.0798C17.5002 5.93762 14.1423 2.57975 10.0002 2.57975ZM0.833496 10.0798C0.833496 5.01714 4.93755 0.913086 10.0002 0.913086C15.0628 0.913086 19.1668 5.01714 19.1668 10.0798C19.1668 15.1424 15.0628 19.2464 10.0002 19.2464C4.93755 19.2464 0.833496 15.1424 0.833496 10.0798Z",
    fill: "#324552"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3718_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.079834)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d51626d54f7c080d1ba50434c451a549.svg";
export { ForwardRef as ReactComponent };